import { render, staticRenderFns } from "./AccountingVatDeclarationPeriodMonth.vue?vue&type=template&id=3dd37304"
import script from "./AccountingVatDeclarationPeriodMonth.vue?vue&type=script&lang=ts"
export * from "./AccountingVatDeclarationPeriodMonth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd37304')) {
      api.createRecord('3dd37304', component.options)
    } else {
      api.reload('3dd37304', component.options)
    }
    module.hot.accept("./AccountingVatDeclarationPeriodMonth.vue?vue&type=template&id=3dd37304", function () {
      api.rerender('3dd37304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/AccountingVatDeclarationPeriodMonth.vue"
export default component.exports